import {
  HELP_PAGE_REQUEST,
  HELP_PAGE_SUCCESS,
  HELP_PAGE_FAIL,
  HELP_PAGE_SEARCH_SUCCESS,
  HELP_PAGE_SEARCH_FAIL,
} from "./types";
import {
  getRequest,
  getRequestWithParams,
  postRequest,
} from "../../services/axios";
import axios from "axios";

export const getAllHelpPageData = () => async (dispatch) => {
  try {
    dispatch({ type: HELP_PAGE_REQUEST });
    const response = await getRequest(`/help/getAllData`);
    const { data } = response;
    // console.log('getAllHelpPageData response = ', data);
    dispatch({ type: HELP_PAGE_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: HELP_PAGE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getHeplPageContentById = (id) => async (dispatch) => {
  try {
    dispatch({ type: HELP_PAGE_REQUEST });
    const response = await postRequest(`/help/getContentById/${id}`);
    // console.log('API getAllHeplPageDataById response = ', response);
    const { content } = response.data.tertiarySubHeading;
    dispatch({ type: HELP_PAGE_SUCCESS, payload: content });
    return response.data.tertiarySubHeading.content;
  } catch (error) {
    dispatch({
      type: HELP_PAGE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

//get searched data
export const getSearchedResult = (searchQuery) => async (dispatch) => {
  try {
    const response = await getRequestWithParams("/help/searchItem", {
      query: searchQuery,
    });
    if (response.data.success) {
      dispatch({
        type: HELP_PAGE_SEARCH_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: HELP_PAGE_SEARCH_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
